import { useQuery } from "@tanstack/react-query";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { WorkflowRunInspector } from "@/components/workflows/WorkflowRunInspector";
import { workflowRunsService } from "@/services/workflowRunsService";
import type { Workflow } from "@/types/aiToolkit";

interface WorkflowRunDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  runId: string | null;
  workflow?: Workflow | null;
}

export function WorkflowRunDialog({ open, onOpenChange, runId, workflow }: WorkflowRunDialogProps) {
  const { data: run } = useQuery({
    queryKey: ["workflow-run", runId],
    queryFn: () => workflowRunsService.getRun(runId!),
    enabled: open && !!runId,
  });

  if (!runId) return null;

  const isReviewing = run?.status === "waiting_approval";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={`max-h-[90vh] overflow-hidden flex flex-col ${
          isReviewing ? "max-w-3xl" : "max-w-2xl"
        }`}
      >
        <DialogHeader>
          <DialogTitle>{isReviewing ? "Review workflow decision" : "Workflow Run"}</DialogTitle>
          <DialogDescription>
            {isReviewing
              ? "Review the email and classifier verdict, then choose Keep email or Move to trash."
              : "Track workflow progress, events, and artifacts for this run."}
          </DialogDescription>
        </DialogHeader>
        <WorkflowRunInspector
          runId={runId}
          workflow={workflow ?? undefined}
          onClose={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
